module.exports = __webpack_public_path__ + "img/77322.3a6bbbcf.svg";